import styles from "./styles.module.scss";

export const EmptyScreen = ({ title, subTitle }: { title: string; subTitle: string }) => (
  <div className={styles.no_decisions}>
    <div className={styles.heading}>{title}</div>
    <div className={styles.sub_text}>{subTitle}</div>
  </div>
);
